import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { loginUrl } from '../pages/Auth/microsoftLogin';

// The V2 sign-in: the same Microsoft sign-in as the current site, and back to V2 afterwards.
export default function V2SignIn() {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const returnUrl = new URLSearchParams(window.location.search).get('returnUrl');
  const target = returnUrl && returnUrl.startsWith('/v2') ? returnUrl : '/v2';

  useEffect(() => {
    if (isAuthenticated()) navigate(target);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="v2-signin">
      <div className="v2-card">
        <h1>CMA V2</h1>
        <p className="v2-muted">Sign in with your CMA Technology account.</p>
        <button type="button" className="v2-btn primary" onClick={() => { window.location.href = loginUrl(target); }}>Sign in with Microsoft</button>
      </div>
    </div>
  );
}
